module.exports = __webpack_public_path__ + "static/img_4948-7e16ffc2f29c77b34f1ba0ffb8c305d4.webp";